/**
 * Query key factory for layout queries. Shared by all layout query and
 * mutation hooks so the read and write sides cannot drift.
 *
 * @see https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories
 */
export const layoutQueryKeys = {
  all: ["layouts"] as const,
  lists: () => [...layoutQueryKeys.all, "list"] as const,
  ids: () => [...layoutQueryKeys.all, "id"] as const,
  id: (layoutId: string) => [...layoutQueryKeys.ids(), layoutId] as const,
  names: () => [...layoutQueryKeys.all, "name"] as const,
  name: (layoutName: string) =>
    [...layoutQueryKeys.names(), layoutName] as const,
};
